import { TextButton } from '@wix/design-system';
import { dataHooks, wixUrl } from '../../utils/constants';
import useMarketplaceHeaderBi, {
  BI_CLICK_DATA,
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';

interface MenuLinkProps {
  pageName: IMPHeaderPageName;
  title: string;
}

const GoToWixSitesLink = ({ pageName, title }: MenuLinkProps) => {
  const { reportClick } = useMarketplaceHeaderBi({ pageName });

  return (
    <TextButton
      dataHook={dataHooks.wixLink}
      as="a"
      weight="normal"
      skin="dark"
      href={wixUrl}
      onClick={() => {
        reportClick({
          clickType: BI_CLICK_TYPES.profileDropdownMenu,
          clickData: BI_CLICK_DATA.goToWix,
        });
      }}
    >
      {title}
    </TextButton>
  );
};

export default GoToWixSitesLink;
